export interface BacklogFilter {
  milestone: string[];
  materialStatus: string[];
  commodityTypes: string[];
  expiredMilestoneFilter: boolean;
  milestoneCount: number;
  materialStatusCount: number;
  commodityTypesCount: number;
}

export const defaultValues: BacklogFilter = {
  milestone: [],
  materialStatus: [],
  commodityTypes: [],
  expiredMilestoneFilter: false,
  milestoneCount: 0,
  materialStatusCount: 0,
  commodityTypesCount: 0,
};
